import React, { useEffect, useState } from 'react';

import { Typography, CircularProgress } from '@material-ui/core';

import axios from '../../axios';

function StakeholderDetails({ data }) {
  //
  console.log(data);
  const [details, setDetails] = useState(null);
  const [isDataAvailable, setIsDataAvailable] = useState(true);

  useEffect(async () => {
    if (!data) {
      setIsDataAvailable(false);
      return;
    }

    const { type } = data;

    if (type === 'USER') {
      const res = await axios({
        method: 'GET',
        url: 'lead/getLead',
        params: {
          leadId: data.id,
        },
      });

      if (res.status == '200' && res.data.data)
        setDetails({
          name: res.data.data.name,
          mobile: res.data.data.mobile,
          email: res.data.data.email,
        });
    } else if (type === 'SCHOOL') {
      const res = await axios({
        method: 'GET',
        url: `school/single/${data.schoolId}`,
      });

      if (res.status == '200' && res.data)
        setDetails({
          name: res.data.schoolName,
          mobile: res.data.contact,
          email: res.data.email,
          address: res.data.address,
        });
    }
  }, []);

  return (
    <>
      {!isDataAvailable ? (
        <Typography>No Data found</Typography>
      ) : (
        <>
          {(() => {
            if (!details) return <CircularProgress />;

            if (data.type === 'USER')
              return (
                <>
                  <Typography>{details.name}</Typography>
                  <Typography>{details.mobile}</Typography>
                  <Typography>{details.email}</Typography>
                </>
              );
            else if (data.type === 'SCHOOL')
              return (
                <>
                  <Typography>{`${details.name} (${details.mobile})`}</Typography>
                  <Typography>{details.address}</Typography>

                  <Typography>{details.email}</Typography>
                </>
              );
          })()}
        </>
      )}
      <div></div>
    </>
  );
}

export default StakeholderDetails;
